export const createRecordWithKey = <T extends { key: string }>(array: T[]) => {
  return array.reduce<Record<string, T>>(
    (p, c) => ({
      ...p,
      [c.key]: c
    }),
    {}
  );
};
